<div fxLayout="column" fxFlex>
    <app-header></app-header>
    <ng-container *ngIf="showSidenav else showFullscreen">
        <mc-sidebar #sidebar>
            <div mc-sidebar-header>
                <mc-nav-group>
                    <mc-nav-home-item [link]="'/'" [label]="'home' | translate" [changesMade]="changesMade"
                        external="false">
                        <mat-icon pre-nav-item>home</mat-icon>
                    </mc-nav-home-item>
                </mc-nav-group>
            </div>
            <div mc-sidebar-body>
                <mc-nav-group>
                    <ng-container *ngFor="let navItem of navOptions">
                        <mc-nav-item *ngIf="navItem.visible" [label]="navItem.sideNavTitle | translate"
                            [link]="navItem.url" [disabled]="navItem.disabled" [changesMade]="changesMade"
                            [basePath]="navItem.basePath">
                        </mc-nav-item>
                    </ng-container>
                </mc-nav-group>
            </div>
            <div mc-sidebar-footer *ngIf="footerText">
                <footer>
                    <a [href]="footerUrl" class="footer-text" target="_blank">{{footerText}}</a>
                </footer>
            </div>
        </mc-sidebar>
        <content-body [bottomOffset]="-25" [mcSidebar]="sidebar">
            <router-outlet (activate)="onRouteChange($event)"></router-outlet>
        </content-body>
    </ng-container>
    <ng-template #showFullscreen>
        <router-outlet (activate)="onRouteChange($event)"></router-outlet>
        <footer *ngIf="footerText" class="full-screen-footer">
            <a [href]="footerUrl" class="footer-text fs" target="_blank">{{footerText}}</a>
        </footer>
    </ng-template>
</div>
